"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var end2end_1 = require("@hudled/end2end");
var interfaces_1 = require("@hudled/interfaces");
var material_1 = require("@mui/material");
var react_redux_1 = require("react-redux");
var react_redux_firebase_1 = require("react-redux-firebase");
var react_router_dom_1 = require("react-router-dom");
var SidebarContainer_1 = __importDefault(require("atomicComponents/atoms/Sidebar/SidebarContainer"));
var RecharglySidebar_1 = __importDefault(require("containersRechargly/Sidebar/RecharglySidebar"));
var single_1 = require("utils/selectors/single");
var DesignSystemSidebar_1 = __importDefault(require("./DesignSystemSidebar"));
var ResetAndCalculateButton_1 = __importDefault(require("./ResetAndCalculateButton"));
var SettingsSidebar_1 = __importDefault(require("./SettingsSidebar"));
var StandardSidebar_1 = __importDefault(require("./StandardSidebar"));
var Sidebar = function () {
    var _a;
    // ToDo: check isSidebarOpened logic for removal
    var myProfile = (0, react_redux_1.useSelector)(single_1.selectProfile);
    var company = (0, react_redux_1.useSelector)(single_1.selectMyCompany);
    var companyHasTransactions = ((_a = company === null || company === void 0 ? void 0 : company.completedOnboardingSteps) === null || _a === void 0 ? void 0 : _a.includes('SET_ACCOUNTING'))
        && ((0, interfaces_1.isSupportedAccPlatform)(company === null || company === void 0 ? void 0 : company.accSoftware) || company.serviceStatsCount);
    var isSettingsPage = (0, react_router_dom_1.useRouteMatch)('/settings');
    var isAdminPage = (0, react_router_dom_1.useRouteMatch)('/admin');
    var isDevPage = (0, react_router_dom_1.useRouteMatch)('/design-system');
    var MainSidebar = end2end_1.IS_RECHARGLY ? RecharglySidebar_1.default : StandardSidebar_1.default;
    return ((0, jsx_runtime_1.jsx)(SidebarContainer_1.default, { children: (0, react_redux_firebase_1.isLoaded)(myProfile) && !myProfile.isUnauthUser && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(isSettingsPage || isAdminPage) && (0, jsx_runtime_1.jsx)(SettingsSidebar_1.default, {}), isDevPage && myProfile.isAdmin && (0, jsx_runtime_1.jsx)(DesignSystemSidebar_1.default, {}), !isSettingsPage && !isAdminPage && !isDevPage && (0, jsx_runtime_1.jsx)(MainSidebar, { isLocked: !companyHasTransactions }), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ px: 4, pb: 4 }, { children: myProfile.isAdmin
                        && ((company === null || company === void 0 ? void 0 : company.isMappingTransactions) || (company === null || company === void 0 ? void 0 : company.isAggregatingServiceStats))
                        && !company.serviceStatsCount
                        && (0, jsx_runtime_1.jsx)(ResetAndCalculateButton_1.default, {}) }))] })) }));
};
exports.default = Sidebar;
